import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const StyledImgContainer = styled(Grid)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledImg = styled.img`
  object-fit: cover;
  width: 100%;
`;
